import React, { useEffect } from 'react'
import { usePlaidLink } from "react-plaid-link";
import { connect } from "react-redux";
import { getPlaidLink } from "redux/ducks/Payment";

// Matches the default button styling react-plaid-link's own <PlaidLink> applies,
// so callers keep rendering identically now that we build the button ourselves.
// Caller-supplied `style` still wins, exactly as before.
const PLAID_BUTTON_STYLE = {
  padding: '6px 4px',
  outline: 'none',
  background: '#FFFFFF',
  border: '2px solid #F1F1F1',
  borderRadius: '4px',
};

// Built on usePlaidLink rather than <PlaidLink> so the flow can be opened
// programmatically as well as by clicking:
//   - onBeforeOpen: return false to block opening (used to require the ACH
//     mandate first) while keeping the Plaid handler preloaded.
//   - autoOpen: open as soon as the handler is ready, for continuing straight
//     into Plaid after the mandate is agreed to.
// Callers that pass neither behave exactly as they did before.
const Go4PlaidLink = ({
  children,
  userId,
  token,
  getPlaidLink,
  autoOpen,
  onAutoOpened,
  onBeforeOpen,
  onClick, // never wired to the button by <PlaidLink> either; kept out of the Plaid config
  className,
  style,
  ...config
}) => {
  useEffect(() => {
    if (!token) getPlaidLink(userId);
  }, [])

  const { open, ready, error } = usePlaidLink({ token, ...config });

  // The hook only re-creates its handler when the token (or product list)
  // changes, so `ready` settles once and this fires a single time; onAutoOpened
  // lets the caller clear its request so a later re-render can't reopen Plaid.
  useEffect(() => {
    if (!autoOpen || !ready) return;

    if (onAutoOpened) onAutoOpened();
    open();
  }, [autoOpen, ready])

  if (!token) return <>Loading...</>

  const handleClick = () => {
    if (onBeforeOpen && onBeforeOpen() === false) return;

    open();
  };

  return (
    <button
      type="button"
      disabled={Boolean(error)}
      className={className}
      style={{ ...PLAID_BUTTON_STYLE, ...style }}
      onClick={handleClick}
    >
      {children}
    </button>
  );
}

const mapStateToProps = (state, ownProps) => ({
  userId: state.session.currentUser.id,
  token: ownProps.token || state.payment.plaidLink
})

const mapDispatchToProps = dispatch => ({
  getPlaidLink: (id) => dispatch(getPlaidLink({ id })),
})

export default connect(mapStateToProps, mapDispatchToProps)(Go4PlaidLink);
